import React, {PureComponent} from 'react';
import styled, {withTheme} from "styled-components";
import {intlWithDirection} from "../i18n";

const Wrapped = styled.div`
    * {
        -webkit-tap-highlight-color: transparent;
        -webkit-touch-callout: none;
        -webkit-user-select: none;
        -khtml-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;

        &:focus {
            outline: none !important;
        }
    }

    input {
        display: none;
    }

    display: inline-block;
    width: ${p => p.size * 2}px; /*=w*/
    height: ${p => p.size}px; /*=h*/
    position: relative;

    .slider {
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        border-radius: ${p => p.size}px;
        box-shadow: 0 0 0 2px ${p => p.theme.colors.surfaceTop}, 0 0 4px ${p => p.theme.colors.surfaceTop};
        cursor: pointer;
        border: 4px solid transparent;
        overflow: hidden;
        transition: 0.2s;
    }

    .slider:before {
        position: absolute;
        content: "";
        width: 100%;
        height: 100%;
        background-color: ${p => p.theme.colors.surfaceTop};
        border-radius: ${p => p.size}px;
        transform: translateX(${p => (p.isRTL ? -1 : 1) * p.size}px);
        transition: 0.2s;
    }

    input:checked + .slider:before {
        transform: translateX(${p => (p.isRTL ? 1 : -1) * p.size}px);
    }
`;

class SwitchButton extends PureComponent {
    toggle = (evt) => {
        evt.stopPropagation();
        this.props.onChange();
    }

    render() {
        return (
            <Wrapped onClick={this.toggle} size={this.props.size || 20} isRTL={this.props.isRTL}>
                <input type="checkbox" checked={this.props.active} onChange={this.toggle}/>
                <div className="slider"></div>
            </Wrapped>
        )
    }
}

export default intlWithDirection(withTheme(SwitchButton));
